import { API_BASE_URL } from "../config/api";

export async function fetchTermsVersions() {
  const res = await fetch(`${API_BASE_URL}/terms-version`);
  if (!res.ok) throw new Error("Erro ao buscar versões dos termos");
  return res.json();
}

export function termsFileUrl(id) {
  return `${API_BASE_URL}/terms-version/${id}/file`;
}
